

import React from 'react';
import { Button, Alert, ModalBody, ModalFooter } from 'reactstrap';
import { Form, Field, reduxForm } from 'redux-form';
import { FormGroup, Label, Row, Card, CardHeader, CardBody, Col } from 'reactstrap';
import { ReduxInput, ReduxTextAreaInput, ReduxButtonList } from '../../components/ReduxInput';
import { isValidEmail } from '../../components/ReduxInput/Validators';
import { Multiselect } from 'react-widgets';


class SettingsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTerminals: []
    }
    this.terminalChange = this.terminalChange.bind(this);
  }

  terminalChange(selectedTerminals) {
    this.setState({
      selectedTerminals
    });
  }

  render() {
    const { handleSubmit, errorText, currentValues, terminals } = this.props;
    const { selectedTerminals } = this.state;
    let terminalsData = terminals.get("data");
    let terminalsDom = [];
    let i = 0;
    terminalsData.forEach(terminal => {
      terminalsDom.push(
        //<Col md="6" key={terminal._id}>
        <FormGroup row key={"terminals" + terminal._id}>
          <Label md={4} >{terminal.name + " Email"}</Label>
          <Col md={8}>
            <Field
              type="text"
              id={"terminals" + i++}
              name={"terminals." + terminal._id}
              component={ReduxInput}
              validate={[isValidEmail]}
            />
          </Col>
        </FormGroup>
        //</Col>
      );
    });

    return (
      <Form
        onSubmit={handleSubmit}
        onKeyPress={e => {
          if (e.key === 'Enter') e.preventDefault();
        }}
        >
        <ModalBody>
          {errorText ? <Alert color="danger">{errorText}</Alert> : null}
          <FormGroup>
            <Label htmlFor="bannerText">Banner Text</Label>
            <Field
              type="text"
              id="bannerText"
              name="bannerText"
              placeholder="Insert Banner Text Here."
              rows="4"
              cols="50"
              component={ReduxTextAreaInput}
            />
          </FormGroup>
          <Card>
            <CardHeader>
              Job Request Emails
            </CardHeader>
            <CardBody>
              {terminalsDom}
            </CardBody>
          </Card>
          {/*
          <Card>
            <CardHeader> Blacklist </CardHeader>
            <CardBody>
              <FormGroup >
                <Label md={6} >Blacklisted Email Domains</Label>
                <Col md={8}>
                  <Field
                    type="text"
                    placeholder='gmail.com, hotmail.com, yopmail.com'
                    id={"blacklist"}
                    name={"blacklist"}
                    component={ReduxButtonList}
                  />
                </Col>
              </FormGroup>
            </CardBody>
          </Card>
          */}
          
          <FormGroup>
            <Button id="updateButton" type="submit" color="primary">
              Update
            </Button>
          </FormGroup>
        </ModalBody>
        
      </Form>
    );

  }
}

export default reduxForm({
  form: 'SettingsForm', // a unique identifier for this form
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true
})(SettingsForm);



// WEBPACK FOOTER //
// ./src/components/SettingsForm/SettingsForm.js